import { render, staticRenderFns } from "./ButtonMini.vue?vue&type=template&id=c579d188&scoped=true"
import script from "./ButtonMini.vue?vue&type=script&lang=js"
export * from "./ButtonMini.vue?vue&type=script&lang=js"
import style0 from "./ButtonMini.vue?vue&type=style&index=0&id=c579d188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c579d188",
  null
  
)

export default component.exports